import React from "react";
import "./styles.css";
import "./base.css";

import Header from "./Header";
import Home from "./Home/Home";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Send from "./Send";
import Cotizador from "./Cotizador/Cotizador";
import ABTestDebugger from "./components/ABTestDebugger";
import SeoHead from "./components/SeoHead";

import { IpLocationProvider } from "./context/IpLocationContext";
import LocationBadge from "./components/LocationBadge";
import abTestingManager from "./utils/abTesting";

const App = (): JSX.Element => {
    const [abConfigReady, setAbConfigReady] = React.useState(false);
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const isStagingSite = hostname === 'alarmitastaging.netlify.app';
    const isProductionSite = hostname === 'alarmita.com' || hostname === 'www.alarmita.com';
    const shouldUseAdminApi = isStagingSite || isProductionSite;

    const defaultDevAbConfigUrl =
        typeof window !== 'undefined'
            ? `${window.location.protocol}//${window.location.hostname}:${window.location.port === '3000' ? '3002' : '3000'}/api/ab-config`
            : 'http://localhost:3000/api/ab-config';

    const abConfigUrl =
        shouldUseAdminApi
            ? 'https://admin.alarmita.com/api/ab-config'
            : process.env.REACT_APP_AB_CONFIG_URL ||
              (process.env.NODE_ENV === 'production'
                  ? 'https://admin.alarmita.com/api/ab-config'
                  : defaultDevAbConfigUrl);

    const queryParams = new URLSearchParams(window.location.search);

    if (queryParams.toString()) {
        const params = Object.fromEntries(queryParams.entries());
        try {
            sessionStorage.setItem("queryParams", JSON.stringify(params));
        } catch { }
    }

    React.useEffect(() => {
        const url = abConfigUrl;
        if (!url) return;

        fetch(url, { cache: 'no-store' })
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => {
                if (data) {
                    abTestingManager.updateRemoteConfig(data);
                } else {
                    abTestingManager.useControlFallback();
                }

                setAbConfigReady(true);
            })
            .catch(() => {
                abTestingManager.useControlFallback();
                setAbConfigReady(true);
            });
    }, [abConfigUrl]);

    if (!abConfigReady) {
        return <div className="App" />;
    }

    return (
        <div className="App">
            <IpLocationProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <SeoHead />
                    <Header />
                    <main id="main-content">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/cotizador" element={<Cotizador />} />
                            <Route path="/send" element={<Send />} />
                            <Route path="*" element={<Navigate to="/" />} />
                        </Routes>
                    </main>
                    <ABTestDebugger />
                    {/* Demo badge (puede removerse en producción) */}
                    {/* <LocationBadge /> */}
                </BrowserRouter>
            </IpLocationProvider>
        </div>
    );
};

export default App;
